module.exports = __webpack_public_path__ + "img/oeillet3_md.b92ba455.jpg";